module.exports = "images/soundOn.6f08893a.png";